import {
  useRefinementList,
  useSearchBox,
  useToggleRefinement,
  useNumericMenu,
  useSortBy,
} from "react-instantsearch";

const asArray = (obj) => {
  return Array.isArray(obj) ? obj : obj ? [obj] : [];
};

const useInstantSearchConfig = (hooksConfig) => {
  const searchBox = useSearchBox();
  const sortBy = useSortBy({ items: hooksConfig.sortBy });
  const refinementHooks = {};

  for (let config of hooksConfig?.refinements || []) {
    switch (config.refinementType) {
      case "list":
        refinementHooks[config.refinementName] = useRefinementList({
          attribute: config.refinementName,
        });
        break;
      case "numeric":
        refinementHooks[config.refinementName] = useNumericMenu({
          attribute: config.refinementName,
          items: [{ label: "All" }],
        });
        break;
      case "datenumeric":
        refinementHooks[config.refinementName] = useNumericMenu({
          attribute: config.refinementName,
          items: [{ label: "All" }],
        });
        break;
      case "toggle":
        refinementHooks[config.refinementName] = useToggleRefinement({
          attribute: config.refinementName,
        });
        break;
      default:
        console.error(`Unknwon refinementType '${config.refinementType}'.`);
    }
  }

  const applyList = (hook, config, filter) => {
    let stateValues = filter ? [...asArray(filter[config.filterName])] : [];
    for (let { value, isRefined } of hook.items) {
      let index = stateValues.indexOf(value);
      if (isRefined && index == -1) hook.refine(value);
      if (isRefined && index > -1) stateValues.splice(index, 1);
    }
    for (let stateValue of stateValues) {
      hook.refine(stateValue);
    }
  };

  const applyNumeric = (hook, config, filter) => {
    let min = filter ? filter[config.filterNameMin] : undefined;
    let max = filter ? filter[config.filterNameMax] : undefined;
    let res = {};
    if (min) res["start"] = min;
    if (max) res["end"] = max;
    hook.refine(JSON.stringify(res));
  };

  const applyNumericDate = (hook, config, filter) => {
    let [min, max] = [undefined, undefined];
    if (filter !== undefined) {
      if (filter[config.filterNameMin])
        min = Math.trunc(new Date(filter[config.filterNameMin]) / 1000);
      if (filter[config.filterNameMax])
        max = Math.trunc(
          new Date(filter[config.filterNameMax]) / 1000 + 24 * 3600 - 1,
        );
    }
    let res = {};
    if (min) res["start"] = min;
    if (max) res["end"] = max;
    hook.refine(JSON.stringify(res));
  };

  const applyToggle = (hook, config, filter) => {
    let filterValue =
      filter &&
      filter[config.filterName] !== "false" &&
      Boolean(filter[config.filterName]);
    hook.refine({
      isRefined: !filterValue,
    });
  };

  const applyState = (state) => {
    for (let config of hooksConfig?.refinements || []) {
      switch (config.refinementType) {
        case "list":
          applyList(
            refinementHooks[config.refinementName],
            config,
            state.filter,
          );
          break;
        case "numeric":
          applyNumeric(
            refinementHooks[config.refinementName],
            config,
            state.filter,
          );
          break;
        case "datenumeric":
          applyNumericDate(
            refinementHooks[config.refinementName],
            config,
            state.filter,
          );
          break;
        case "toggle":
          applyToggle(
            refinementHooks[config.refinementName],
            config,
            state.filter,
          );
          break;
        default:
          console.error(`Unknwon refinementType '${config.refinementType}'.`);
      }
    }
    if (state.search != searchBox.query) searchBox.refine(state.search);
    if (state.sort && state.sort.ordering != sortBy.currentRefinement)
      sortBy.refine(state.sort.ordering);
  };

  return { applyState };
};

export default useInstantSearchConfig;
